<div class="sa-ticket-details-description" name="ticketDescriptionForm">
  <div class="ticket-details-description-header">
    <div class="hd-icon hd-icon-filetype-document"></div>
    <div class="ticket-details-description-Title">{{ 'ticketDetailsDescription_Title_Caption' | xsI18n }}</div>
  </div>

  <div class="ticket-details-description">
    <div class="text-input-control">
      <textarea
        class="text-input-field ng-pristine ng-untouched ng-valid-maxlength ng-not-empty ng-valid ng-valid-required"
        cdkTextareaAutosize
        maxlength="4000"
        [(ngModel)]="ticketDescription"
        [ngModelOptions]="{ standalone: true }"
        (blur)="setDirty()"
        [ngClass]="{ 'has-error': isChanged && !isValid() }"
        [disabled]="!editable"
        rows="3"
        placeholder="{{
          (editable ? 'ticketDetailsDescription_Edit_Placeholder' : 'ticketDetailsDescription_Placeholder') | xsI18n
        }}"
      ></textarea>
    </div>
  </div>

  <div class="ticket-details-description-devices">
    <div class="ticket-details-description-device-wrapper" *ngIf="editable || hasAssociatedDevices()">
      <div class="ticket-details-description-devices-label">
        {{ 'ticketDetailsDescription_Devices_Label' | xsI18n }}
      </div>
      <div
        class="ticket-details-description-devices-group"
        [ngClass]="{ 'ticket-details-description-border': editable }"
      >
        <div class="ticket-details-description-devices-list">
          <div class="ticket-details-description-device" *ngFor="let device of getAssociatedDevices()">
            <div class="ticket-details-description-device-icon" [ngClass]="getDeviceIconClass(device.platform, null)">
              <div
                class="ticket-details-description-device-screenicon"
                [ngClass]="getDeviceScreenIconClass(device.platform, null, device.mcConnectionName)"
              ></div>
            </div>
            <div class="ticket-details-description-device-value-placeholder" *ngIf="!device.deviceName">
              {{ 'ticketDetailsDescription_Devices_Device_Id_Placeholder' | xsI18n }}
            </div>
            <div class="ticket-details-description-device-value" *ngIf="device.deviceName">
              <div>{{ device.deviceName }}</div>
            </div>
            <div
              class="ticket-details-description-device-disassociate hd-icon icon-md hd-icon-close"
              *ngIf="editable"
              type="button"
              (click)="disassociateDevice(device)"
            ></div>
          </div>
          <ssp-search-and-pick-v2
            *ngIf="editable"
            #searchAndPickDevice
            [itemTemplate]="deviceCardTemplate"
            idField="DeviceId"
            placeholder="{{ 'searchAndPick_Empty_Placeholder' | xsI18n }}"
            [searchResource]="searchResource"
            (onPick)="addAssociatedDevice($event)"
            (onBlur)="addUnmanagedDevice($event)"
            (onPanelToggle)="setManagedDeviceMode($event)"
            class="recipients-search-and-pick"
          >
          </ssp-search-and-pick-v2>
          <ng-template #deviceCardTemplate let-item>
            <div class="ticket-details-description-devices-search-row">
              <div
                class="ticket-details-description-devices-search-icon"
                [ngClass]="getDeviceIconClass(item.family, null)"
              >
                <span
                  class="ticket-details-description-devices-search-screen-icon"
                  [ngClass]="getDeviceScreenIconClass(item.family, null, item.mcConnectionName)"
                ></span>
              </div>
              <div
                class="ticket-details-description-devices-search-value"
                sa-ellipsis
                [fullText]="item.deviceName"
              ></div>
            </div>
          </ng-template>
        </div>
      </div>
      <!-- device list and search group -->
    </div>
    <!-- Wrapper -->
  </div>
</div>
